import { Checkbox, FormControlLabel } from "@mui/material";
import { useFormikContext } from "formik";
import { AddSolutionFormValues } from "../../types";

function ReadyForSaleCheckbox() {
  const context = useFormikContext<AddSolutionFormValues>();

  return (
    <FormControlLabel
      control={
        <Checkbox
          id="solution-is-ready-for-sale"
          checked={context.values["solution-is-ready-for-sale"]}
          onChange={context.handleChange}
          slotProps={{ input: { "aria-label": "Ready For Sale" } }}
        />
      }
      label="Ready for Sale"
    />
  );
}

export default ReadyForSaleCheckbox;
